import { useState } from 'react';
import { SelectorCliente } from '../components/SelectorCliente';
import { CabeceraPagina } from '../components/Armazon';
import { Aviso, Boton, Cargando, Tarjeta, Vacio } from '../components/ui';
import { api, qs } from '../lib/api';
import { useDatos, useSesion } from '../lib/sesion';
import type { ClienteResumen, Pagina } from '../lib/tipos';

export function Clientes() {
  const { es } = useSesion();
  const [seleccionado, setSeleccionado] = useState<ClienteResumen | null>(null);
  const [mantenimiento, setMantenimiento] = useState(false);
  const [texto, setTexto] = useState('');
  const [consulta, setConsulta] = useState('');
  const [pagina, setPagina] = useState(1);

  const { datos, cargando, error } = useDatos(
    (s) => mantenimiento && es('ADMIN') ? api.get<Pagina<ClienteResumen>>(`/clients${qs({ q: consulta, page: pagina, pageSize: 25 })}`, s)
      : Promise.resolve({ rows: seleccionado ? [seleccionado] : [], total: seleccionado ? 1 : 0, page: 1, pageSize: 25 }),
    [consulta, pagina, mantenimiento, seleccionado],
  );

  const paginas = Math.max(1, Math.ceil((datos?.total ?? 0) / (datos?.pageSize ?? 25)));

  return (
    <>
      <CabeceraPagina
        titulo="Clientes"
      />

      <div className="pila">
        <SelectorCliente onSeleccion={setSeleccionado} />
        {es('ADMIN') && <Boton variante="secundario" onClick={() => setMantenimiento(v => !v)}>{mantenimiento ? 'Cerrar mantenimiento' : 'Listado para mantenimiento'}</Boton>}
        {mantenimiento && <form
          className="fila"
          onSubmit={(e) => {
            e.preventDefault();
            setPagina(1);
            setConsulta(texto.trim());
          }}
        >
          <input
            type="search"
            placeholder="Nombre, ciudad o Id. de cliente"
            value={texto}
            onChange={(e) => setTexto(e.target.value)}
            style={{ maxWidth: 340 }}
            aria-label="Buscar clientes"
          />
          <Boton type="submit" variante="secundario">
            Buscar
          </Boton>
        </form>}

        {error && <Aviso tono="error">{error}</Aviso>}

        {(seleccionado || mantenimiento) && <Tarjeta sinRelleno>
          {cargando ? (
            <Cargando />
          ) : datos?.rows.length ? (
            <>
              <table className="tabla">
                <thead>
                  <tr>
                    <th>Id.</th>
                    <th>Nombre comercial</th>
                    <th>Población</th>
                    <th>Comercial</th>
                    <th>Riesgo</th>
                  </tr>
                </thead>
                <tbody>
                  {datos.rows.map((c) => (
                    <tr key={c.id}>
                      <td className="codigo">{c.externalId}</td>
                      <td style={{ fontWeight: 500 }}>{c.commercialName}</td>
                      <td className="sutil">
                        {[c.city, c.province].filter(Boolean).join(' · ') || '—'}
                      </td>
                      <td className="sutil">
                        {c.salesperson
                          ? `${c.salesperson.name ?? 'Sin nombre'} (${c.salesperson.externalId})`
                          : 'Sin asignar'}
                      </td>
                      <td className="sutil">{c.riskDescription ?? '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {paginas > 1 && (
                <div className="fila" style={{ justifyContent: 'space-between', padding: '12px 24px' }}>
                  <span className="sutil">
                    {datos.total} clientes · página {pagina} de {paginas}
                  </span>
                  <div className="fila">
                    <Boton variante="secundario" tam="s" disabled={pagina <= 1} onClick={() => setPagina(pagina - 1)}>
                      Anterior
                    </Boton>
                    <Boton
                      variante="secundario"
                      tam="s"
                      disabled={pagina >= paginas}
                      onClick={() => setPagina(pagina + 1)}
                    >
                      Siguiente
                    </Boton>
                  </div>
                </div>
              )}
            </>
          ) : (
            <Vacio titulo="Ningún cliente coincide" />
          )}
        </Tarjeta>}
      </div>
    </>
  );
}
